<template>
  <main>
      <div class="tab_title" :class="{jp: $region === 'jp'}">
        <a class="cate news_title" ga-data="1010101" :class="{jp: $region === 'jp'}">
          <p>{{$t('news.newsNotice')}}</p>
          <div class="focus_dot"></div>
        </a>
      </div>
    <div class="container">

      <!-- 公告聲明 -->
      <div class="notice" :class="{jp: $region === 'jp'}" v-if="topNews.statement">
        <h4>
          <!-- Komoe Game {{$t('news.noticeDeclare')}} -->
          {{topNews.statement.title}}
          <span class="imp">{{$t('news.important')}}</span>
          <span class="date" v-html="topNews.statement.publish_time"></span>
        </h4>
        <p v-html="topNews.statement.content"></p>
      </div>

      <!-- 新聞timeline -->
      <div class="newsline">
        <!-- 置頂新聞 -->
        <div class="mount_block" v-if="topNews && topNews.top_image_large">
          <div class="title">
            {{$t('news.newsAtt')}}
            <div class="separate"></div>
            <hr />
          </div>
          <router-link tag="div" :to="{name: 'activeH5'}" class="title_active"  :class="{jp: $region === 'jp'}">
             最新イベント 
            <hr />
          </router-link>
          <div class="list">
            <!-- 大圖新聞 -->
            <!-- :href="topNews.top_image_large.url||'/newsdetail/#'+topNews.top_image_large.news_id" -->
            <a
              @click="toDetail({
								url: topNews.top_image_large.url,
								id: topNews.top_image_large.news_id
							})"
              class="notice_item"
              v-if="topNews.top_image_large"
            >
              <div
                class="img_box"
                :style="{backgroundImage:'url('+topNews.top_image_large.image_small+')'}"
              ></div>
              <div class="info_box">
                <h4 v-html="topNews.top_image_large.title"></h4>
                <p v-html="topNews.top_image_large.summary"></p>
                <div class="bottom">
                  <span class="type" v-text="getNewsType(topNews.top_image_large.type)"></span>
                  <span class="date" v-html="getDateString(topNews.top_image_large.publish_time)"></span>
                </div>
              </div>
            </a>
            <!-- 小圖新聞 -->
            <template v-if="topNews.top_image_small_list && topNews.top_image_small_list.length > 0">
              <!-- :href="n.url||'/newsdetail/#'+n.news_id" -->
              <a
                class="notice_item"
                v-for="n in topNews.top_image_small_list"
                @click="toDetail({
									url: n.url,
									id: n.news_id
								})"
                :key="n.news_id"
              >
                <div class="img_box" :style="{backgroundImage:'url('+n.image_small+')'}"></div>
                <div class="info_box">
                  <h4 v-html="n.title"></h4>
                  <p v-html="n.summary"></p>
                  <div class="bottom">
                    <span class="type" v-text="getNewsType(n.type)"></span>
                    <span class="date" v-html="getDateString(n.publish_time)"></span>
                  </div>
                </div>
              </a>
            </template>
            <!-- 置頂新聞 -->
            <template v-if="topNews.top_news_list && topNews.top_news_list.length > 0">
              <!-- :href="n.url||'/newsdetail/#'+n.news_id" -->
              <a
                class="notice_item"
                v-for="n in topNews.top_news_list"
                @click="toDetail({
									url: n.url,
									id: n.news_id
								})"
                :key="n.news_id"
              >
                <div class="notice_tit">
                  <span class="type" v-html="getNewsType(n.type)"></span>
                  <p v-html="n.title"></p>
                  <span class="date" v-html="getDateString(n.publish_time)"></span>
                </div>
              </a>
            </template>
          </div>
        </div>
        <!-- 普通新聞 -->
        <div class="mount_block" v-for="m in month_list" :key="m.month">
          <div class="title_1">
            {{m.month}}
            <div class="separate"></div>
            <hr />
          </div>
          <div class="list">
            <a
              class="notice_item"
              v-for="n in m.items"
              :key="n.news_id"
              @click="toDetail({
									url: n.url,
									id: n.news_id
								})"
            >
              <!-- :href="n.url||'/newsdetail/#'+n.news_id" -->
              <!-- <span class="timer" v-text="getMonthString(n.publish_time)"></span> -->
              <div class="notice_tit">
                <span class="type type_1" v-text="getNewsType(n.type)"></span>
                <p v-text="n.title"></p>
                <span class="icon">
                  <img src="../../../assets/images/news/arrow_right_circle.svg" alt />
                </span>
              </div>
            </a>
          </div>
        </div>
        <!-- 查看更多 -->
        <div v-if="have_more" class="show_more" @click="getNews" ga-data="203002">
          {{$t('news.checkMore')}}
          <span class="icon">
            <img src="../../../assets/images/news/arrow_down_circle.svg" alt />
          </span>
        </div>

        <div v-else class="show_more gray">
          <span v-if="$region !== 'jp'">{{$t('news.noMoreNews')}}</span>
        </div>
      </div>

      <!-- 回到顶部 -->
      <a href="#" class="toTop" v-show="totop"></a>
    </div>
  </main>
</template>

<script>
export default {
  name: "newsH5",
  data() {
    return {
      topNews: {},
      newsList: [],
      month_list: [],
      totop: false,
      page_num: 1,
      have_more: true
    };
  },
  methods: {
    toDetail(param) {
        this.$router.push({ name: "newsDetailH5", params: { id: param.id } });
    },
    getNewsType(id) {
      switch (id) {
        case 1:
          return this.$t('news.notice');
          // break;
        case 2:
          return this.$t('news.preserve');
          // break;
        case 3:
          return this.$t('news.news');
          // break;
        case 4:
          return this.$t('news.active');
          // break;
        case 5:
          return this.$t('news.declare');
          // break;
        default:
          return id;
          // break;
      }
    },
    getNews() {
      this.$apis.home.getNewsList(this.page_num, 20).then(data => {
        let res = data.data;
        // console.log("news",res)
        if (res.code == 0) {
          if (res.data.length > 0) {
            this.newsList.push(...res.data);
            this.page_num++;
            this.handleNews(res.data);
          } else {
            this.have_more = false;
          }
        } else {
          // console.error(res.message);
        }
      });
    },
    handleNews(nl) {
      let months = this.month_list;
      // console.log("months0",nl)
      nl.forEach(i => {
        // console.log("months1",i)
        let new_one = true;
        months.forEach(j => {
          // console.log("months2",j)
          if (j.month == this.getMonthString(i.publish_time)) {
            j.items.push(i);
            new_one = false;
          }
        });
        if (new_one) {
          // console.log("months3",new_one)
          months.push({
            month: this.getMonthString(i.publish_time),
            items: [i]
          });
        }
      });
      // console.log("months",months)
      // this.month_list = months
    },
    handleScroll() {
      if (
        self.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      ) {
        this.totop = true;
      } else {
        this.totop = false;
      }
    },
    getDateString(t) {
      if (!t) {
        return 0;
      }
      let ts = new Date(t.replace(/-/g, '/'));
      let addzero = i => {
        if (i > 9) {
          return String(i);
        } else {
          return "0" + i;
        }
      };
      return (ts.getFullYear() +"/" +addzero(ts.getMonth() + 1) +"/" +addzero(ts.getDate()));
    },
    getMonthString(t) {
      if (!t) {
        return 0;
      }
      let ts = new Date(t.replace(/-/g, '/'));
      let zero = ts.getMonth() + 1 > 9 ? "" : "0";
      return ts.getFullYear() + "/" + zero + (ts.getMonth() + 1);
    }
  },
  mounted() {
    // 请求置顶新闻
    this.$apis.home.getNewsTop().then(data => {
      let res = data.data;
      // console.log("topnews",res)
      if (res.code == 0) {
        this.topNews = res.data;
      } else {
        // console.error(res.message);
      }
    });
    this.getNews();

    window.addEventListener("scroll", this.handleScroll);
  }
};
</script>

<style lang="scss" scoped>
div,
p,
h4,
h5,
span {
  margin: 0;
  padding: 0;
}
a {
  color: inherit;
  text-decoration: none;
}
span {
  font-weight: normal;
  &.imp {
    display: inline-block;
    width: 0.5rem;
    line-height: 0.16rem;
    background: #ffb13b;
    border-radius: 0.08rem;
    color: #ffffff;
    font-size: 0.12rem;
    text-align: center;
  }
  &.date {
    display: inline-block;
    font-size: 0.12rem;
    padding-left: 0.12rem;
    line-height: 0.2rem;
    color: #999999;
  }
  &.type {
    display: inline-block;
    width: .68rem;
    line-height: .19rem;
    height: .18rem;
    background: #50BBE5;
    border-radius: 0.08rem;
    color: #ffffff;
    font-size: 0.1rem;
    text-align: center;
  }
}
.tab_title {
    text-align: center;
    margin-top: 0.58rem;
    padding-top: 0.1rem;
    font-size: 0.14rem;
    border-top: 0.01rem solid #eee;
    .cate {
      display: inline-block;
      width: 188px;
      position: relative;
      &.jp {
        width: auto;
      }
      p {
        color: #444444;
        &.gray {
          color: #bdbdbd;
        }
      }
      .focus_dot {
        margin: .06rem auto 0 auto;
        width: 0.32rem;
        height: 0.03rem;
        border-radius: 0.03rem;
        background: #50bbe5;
      }
    }
  }
.container {
  width: 100%;
  overflow: hidden;
  margin: 0 auto;
  box-sizing: border-box;
  min-height: calc(100vh - 2.42rem);
  .notice {
    border: 0.01rem solid #eeeeee;
    border-radius: 0.1rem;
    padding:0.3rem 0.2rem;
    margin-bottom: 0.4rem;
    &.jp {
      padding: 0.3rem 0;
      border: none;
      p {
        word-break: break-all;
      }
    }
    h4 {
      font-size: 0.2rem;
      color: #333333;
      margin-bottom: 0.2rem;
      .date {
        float: right;
      }
    }
    p {
      font-size: 0.14rem;
      color: #999999;
      text-indent: 2em;
    }
  }
  .newsline {
    .mount_block {
      position: relative;
      padding-top: 0.3rem;
      margin-bottom: 0.24rem;
      .title_active{
        position: absolute;
        top: 0rem;
        left: .9rem;
        border-top: 0.01rem solid #eeee;
        border-bottom: 0.01rem solid #eeee;
        width: 100%;
        font-size: .14rem;
        line-height: .32rem;
        color: #ccc;
        padding-left: 0.06rem;
        hr {
          width: .36rem;
          border: 0;
          height: .04rem;
          background: #a2a2a2;
          position: absolute;
          top: .23rem;
          left: .26rem;
          border-radius: 0.1rem;
        }
      }
      .title {
        position: absolute;
        top: 0rem;
        border-top: 0.01rem solid #eeee;
        border-bottom: 0.01rem solid #eeee;
        width: 100%;
        font-size: .14rem;
        line-height: .32rem;
        color: #000000;
        padding-left: 0.06rem;
        hr {
          width: .36rem;
          border: 0;
          height: .04rem;
          background: #50bbe5;
          position: absolute;
          top: .23rem;
          left: .26rem;
          border-radius: 0.1rem;
        }
      }
      .title_1 {
        position: absolute;
        top: -0.07rem;
        border-bottom: 0.02rem solid #eeee;
        width: 100%;
        font-size: .16rem;
        line-height: .42rem;
        color: #ccc;
        padding-left: .16rem;
        hr {
          width: .36rem;
          border: 0;
          height: .06rem;
          background: #a2a2a2;
          position: absolute;
          top: .31rem;
          left: 0.26rem;
        }
      }
      .list {
        a {
          padding: 0 0.16rem;
          display: flex;
          justify-content: flex-start;
          padding-top: 0.22rem;
          text-decoration: none;
          color: #444444;
          overflow: hidden;
          .img_box {
            width: 1.2rem;
            height: 0.8rem;
            background: black;
            margin-right: 0.06rem;
            background-size: cover;
            background-position: center center;
            background-repeat: no-repeat;
            flex-shrink: 0;
            margin-left: 0.04rem;
          }
          .info_box {
            display: flex;
            flex-direction: column;
            flex: 1;
            width: 60%;
            h4 {
              font-size: .14rem;
              margin-left: -0.08rem;
              color: #444444;
              margin-bottom: .12rem;
              overflow:hidden;
              text-overflow:ellipsis;
              white-space:nowrap;
            }
            p {
              font-size: 0.1rem;
              color: #999999;
              line-height: .14rem;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              display: -webkit-box;
              height: .28rem;
              margin-bottom: 0.08rem;
            }
            .bottom {
              display: flex;
              .date {
                float: right;
              }
            }
          }
          .notice_tit {
            display: flex;
            align-items: center;
            width: 100%;
            span {
              flex-grow: 0;
              flex-shrink: 0;
              &.icon {
                width: 0.12rem;
                margin-right: .1rem;
                img {
                  display: block;
                  border-radius: 0.06rem;
                }
              }
            }
            p {
              flex-grow: 1;
              font-size: 0.12rem;
              color: #444444;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
          &:last-child {
            border-bottom: 0;
          }
        }
      }
    }
    .show_more {
      text-align: center;
      font-size: 0.16rem;
      line-height: 0.8rem;
      color: #444444;
      cursor: pointer;
      &.gray {
        color: #cccccc;
      }
      img {
        width: 0.12rem;
      }
    }
  }
  .toTop {
    display: block;
    position: fixed;
    width: 0.42rem;
    height: 0.38rem;
    right: 0.2rem;
    bottom: 0.6rem;
    background: url(../../../assets/images/news/totop_nor.svg) center center
      no-repeat;
    background-size: contain;
  }
}
</style>
